import { Button, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';

interface IErrorPage {
	errorMessage: string;
}

export function ErrorPage(props: IErrorPage) {
	const { t } = useTranslation();
	const { errorMessage } = props;
	const { logout } = useAuth0();

	return (
		<div className='error-page'>
			<Row>
				<h4 className='err-msg'>{errorMessage}</h4>
			</Row>
			<Row className='mt-4'>
				<Button
					className='btn-err-page w-100'
					onClick={() =>
						logout({
							logoutParams: { returnTo: window.location.origin }
						})
					}
				>
					{t('Back to Login')}
				</Button>
			</Row>
		</div>
	);
}
